import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

export const { mapFields: mapCommissionsFields } = createHelpers({
  getterType: `commissions/getField`,
  mutationType: `commissions/updateField`
});

const state = {
  Commissions: []
};

const actions = {
  resetCommissions({ commit }) {
    commit("setCommissions", []);
  },
  getCommissions({ dispatch }, commissionsQuery) {
    return new Promise((resolve, reject) => {
      dispatch("message/reset", null, { root: true });

      var response = HTTP.post("OMS/ListCommissionSummaries", commissionsQuery);
      response
        .then(function(data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissionss : " + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject();
        });
    });
  },
  addCommissions({ state, commit }) {
    commit("setCommissions", state.Commissions);
  },
  downloadCommissions({ dispatch }, commissionsQuery) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "DealerPortal/DownloadCommissionsPDF",
        commissionsQuery,
        { responseType: "arraybuffer" }
      );
      response
        .then(function(data) {
          if (data.status == 204) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Report not found",
                httpStatus: 500
              }),
              { root: true }
            );
            reject();
            return;
          }
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Agent-${JSON.parse(data.config["data"]).dealerID}Commissions.pdf`
          );
          document.body.appendChild(link);
          link.click();
          resolve();
        })
        .catch(err => {
          let msgBuffer = Buffer.from(err.response.data, "utf8");
          let msgStringify = JSON.stringify(msgBuffer);
          let parseMsg = JSON.parse(msgStringify);
          let message = '';
          
          if (parseMsg.type == "Buffer") message = msgBuffer.toString("utf8");
          else message = "Error in getting Commissionss : " + err.message;
          dispatch(
            "message/setMessage",
            new httpError({
              message: message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject();
        });
    });
  },
  emailCommissions({ dispatch }, commissionsQuery) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "DealerPortal/EmailCommissionsPDF",
        commissionsQuery
      );
      response
        .then(function(data) {
          if (data.status == 204) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Report not found",
                httpStatus: 500
              }),
              { root: true }
            );
            reject();
            return;
          }
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Email has been sent",
              httpStatus: 200
            }),
            { root: true }
          );
          resolve();
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissionss : " + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject();
        });
    });
  }
};

const mutations = {
  setCommissions(state, Commissions) {
    state.Commissions = Commissions;
  },

  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
